import axios from 'axios';
import {
  getToken,
  removeToken
} from '@/utils/auth';

function req (conf) {
  // create an axios instance
  const service = axios.create({
    baseURL: conf.baseURL, // url = base url + request url
    withCredentials: true,
    timeout: 10 * 1000,
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    }
  });

  // request interceptor
  service.interceptors.request.use(
    config => {
      config.headers['token'] = getToken();
      config.headers['t'] = new Date().getTime() + parseInt(Math.random() * 100);
      return config;
    },
    error => {
      console.log(error);
      return Promise.reject(error);
    }
  );

  // response interceptor
  service.interceptors.response.use(
    response => {
      const res = response.data;
      if (res.code === 0 || res.code === 10000 || (res instanceof Blob) || response.status === 200) {
        return res;
      } else {
        // Message({
        //   message: res.msg || 'error',
        //   type: 'error',
        //   duration: 3 * 1000
        // });
        if (res.code === 200000) { // 如果token过期 清除token
          removeToken();
          // location.reload();
          // Message({
          //   message: '登录过期，请重新登录',
          //   type: 'error',
          //   duration: 2000,
          //   onClose: () => {
          //     router.push({
          //       name: 'login'
          //     });
          //   }
          // });
        }
        return Promise.reject(res.msg || 'error');
      }
    },
    error => {
      console.log('err' + error); // for debug
      return Promise.reject(error);
    }
  );
  /**
   * get请求参数处理
   * @param {*} params 参数对象
   * @param {*} openDefultParams 是否开启默认参数?
   */
  service.adornParams = (params = {}) => {
    return params
  }
  /**
   * post请求数据处理
   */
  service.adornData = (data = {}) => {
    return data
  }
  return service
}

export default req;
